import React from 'react';
import PropTypes from 'prop-types';

/**
 * Bank Hosted integration requires the browser itself to POST
 * access_code + encRequest to SmartPay's transaction page — this is a
 * real page navigation, not an AJAX call. This component renders a
 * hidden form and submits it automatically on mount.
 */
class SmartPayRedirectForm extends React.Component {
  formRef = React.createRef();

  componentDidMount() {
    // Give React one tick to paint the hidden inputs, then leave the SPA.
    this.formRef.current.submit();
  }

  render() {
    const { actionUrl, accessCode, encRequest } = this.props;

    return (
      <div className="smartpay-redirect">
        <p>Redirecting you to the secure payment page…</p>
        <form ref={this.formRef} method="POST" action={actionUrl} style={{ display: 'none' }}>
          <input type="hidden" name="access_code" value={accessCode} />
          <input type="hidden" name="encRequest" value={encRequest} />
        </form>
      </div>
    );
  }
}

SmartPayRedirectForm.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  accessCode: PropTypes.string.isRequired,
  encRequest: PropTypes.string.isRequired,
};

export default SmartPayRedirectForm;
